// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__E0YgG","requiredAsterisk":"Info_requiredAsterisk__3qDUX"};